"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vec2Zero = {
    x: 0,
    y: 0
};
function vec2Equals(a, b) {
    return a.x === b.x && a.y === b.y;
}
exports.vec2Equals = vec2Equals;
function vec2Create(x, y) {
    return {
        x: x,
        y: y
    };
}
exports.vec2Create = vec2Create;
function vec2Add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
exports.vec2Add = vec2Add;
function vec2Sub(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
exports.vec2Sub = vec2Sub;
function vec2Scale(a, s) {
    return {
        x: a.x * s,
        y: a.y * s
    };
}
exports.vec2Scale = vec2Scale;
function vec2Perp(a) {
    return {
        x: -a.y,
        y: a.x
    };
}
exports.vec2Perp = vec2Perp;
function vec2Flip(v) {
    return {
        x: -v.x,
        y: -v.y
    };
}
exports.vec2Flip = vec2Flip;
function vec2Dot(a, b) {
    return a.x * b.x + a.y * b.y;
}
exports.vec2Dot = vec2Dot;
function vec2Length(a) {
    return Math.sqrt(a.x * a.x + a.y * a.y);
}
exports.vec2Length = vec2Length;
function vec2Normalize(a) {
    var length = vec2Length(a);
    if (length === 0) {
        return { x: 0, y: 0 };
    }
    return { x: a.x / length, y: a.y / length };
}
exports.vec2Normalize = vec2Normalize;
function vec2Dist(a, b) {
    return vec2Length(vec2Sub(a, b));
}
exports.vec2Dist = vec2Dist;
function abs(v) {
    return vec2Create(Math.abs(v.x), Math.abs(v.y));
}
exports.abs = abs;
